//@ts-check
import React from 'react';
import Styled from '../../lab/Styled';
import { Checkboard } from 'react-color/lib/components/common';
/**
 * @param {import('./types').ColoredIconProps} props
 */

var ColoredIcon = function ColoredIcon(_ref) {
  var color = _ref.color,
      children = _ref.children;
  var isOpaque = color.indexOf('rgb(') > -1;
  return React.createElement(Styled, {
    styles: styles,
    theme: false,
    name: "ECColoredIcon"
  }, function (classes) {
    return React.createElement("div", {
      className: classes.root
    }, children, React.createElement("div", {
      style: {
        backgroundColor: color
      },
      className: classes.coloredUnderline
    }, React.createElement("div", {
      style: {
        opacity: isOpaque ? 0 : 1
      }
    }, React.createElement(Checkboard, {
      size: 4
    }))));
  });
};

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'inline-block'
    },
    coloredUnderline: {
      border: '1px solid rgba(0,0,0,0.2)',
      position: 'absolute',
      height: 5,
      width: theme.spacing(3),
      left: 0,
      right: 0,
      margin: 'auto'
    }
  };
};

ColoredIcon.defaultProps = {};
export default ColoredIcon;